import { useTranslation } from 'react-i18next';

interface Item {
	area: string;
	positions: {
		title: string;
		location: string;
		link: string;
	}[];
}

export default function Recruitment() {
	const { t } = useTranslation();

	const items: Item[] = [
		{
			area: t('recruitment.area.engineering'),
			positions: [
				{
					title: t('recruitment.position.fullStackDeveloper'),
					location: t('recruitment.location.remoteSanFernando'),
					link: '/contact',
				},
			],
		},
		{
			area: t('recruitment.area.testingQA'),
			positions: [
				{
					title: t('recruitment.position.qaEngineer'),
					location: t('recruitment.location.sanFernando'),
					link: '/contact',
				},
			],
		},
	];

	return (
		<section className="relative">
			{/* Blurred shape */}
			<div
				className="pointer-events-none absolute left-1/2 top-0 -z-10 ml-24 -translate-x-1/2 -translate-y-1/3 opacity-50 blur-2xl"
				aria-hidden="true"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="434" height="427">
					<defs>
						<linearGradient
							id="bs3-a"
							x1="19.609%"
							x2="50%"
							y1="14.544%"
							y2="100%"
						>
							<stop offset="0%" stopColor="#38B2AC" />
							<stop offset="100%" stopColor="#38B2AC" stopOpacity="0" />
						</linearGradient>
					</defs>
					<path
						fill="url(#bs3-a)"
						fillRule="evenodd"
						d="m410 0 461 369-284 58z"
						transform="matrix(1 0 0 -1 -410 427)"
					/>
				</svg>
			</div>

			<div className="mx-auto max-w-6xl px-4 sm:px-6">
				<div className="py-6 md:py-12">
					{/* Section header */}
					<div className="mx-auto max-w-3xl text-center">
						<h2 className="h2 bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 bg-clip-text pb-4 text-transparent">
							{t('recruitment.title')}
						</h2>
						<p className="text-lg text-slate-400">
							{t('recruitment.description')}
						</p>
					</div>
				</div>
			</div>

			{/* Positions */}
			<div className="relative px-4 sm:px-6">
				{/* Blurred shape */}
				<div
					className="pointer-events-none absolute left-1/2 top-0 ml-24 -translate-x-1/2 translate-y-1/3 opacity-40 blur-2xl"
					aria-hidden="true"
				>
					<svg xmlns="http://www.w3.org/2000/svg" width="434" height="427">
						<defs>
							<linearGradient
								id="bs2-a"
								x1="19.609%"
								x2="50%"
								y1="14.544%"
								y2="100%"
							>
								<stop offset="0%" stopColor="#38B2AC"></stop>
								<stop offset="100%" stopColor="#38B2AC" stopOpacity="0"></stop>
							</linearGradient>
						</defs>
						<path
							fill="url(#bs2-a)"
							fillRule="evenodd"
							d="m346 898 461 369-284 58z"
							transform="translate(-346 -898)"
						></path>
					</svg>
				</div>

				<div className="mx-auto max-w-3xl py-12 md:py-20">
					<h3 className="h3 inline-flex bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 bg-clip-text pb-8 text-transparent md:pb-16">
						{t('recruitment.openPositions')}
					</h3>
					<div className="space-y-8">
						{items.map((item, index) => (
							<div key={index}>
								<h4 className="inline-flex bg-gradient-to-r from-teal-500 to-teal-200 bg-clip-text pb-3 font-medium text-transparent">
									{item.area}
								</h4>
								<ul className="divide-y divide-slate-800">
									{item.positions.map((position, index) => (
										<li
											key={index}
											className="flex flex-col flex-wrap justify-between py-5 md:flex-row"
										>
											<span className="mr-2 font-medium text-slate-50">
												{position.title}
											</span>
											<a
												className="group inline-flex text-sm font-medium text-teal-500"
												href={position.link}
											>
												{position.location}{' '}
												<span className="ml-1 tracking-normal transition-transform duration-150 ease-in-out group-hover:translate-x-0.5">
													-&gt;
												</span>
											</a>
										</li>
									))}
								</ul>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
